module.exports = __webpack_public_path__ + "img/tvBg_as.a642bbea.png";